<script setup lang="ts">
  import { type ButtonShape, type ButtonSize, VButton } from "@krainovsd/vue-ui";

  type Props = {
    value?: string | number | null;
    placeholder: string;
    active?: boolean;
    size?: ButtonSize;
    shape?: ButtonShape;
  };

  const props = withDefaults(defineProps<Props>(), {
    value: null,
    active: false,
    size: "large",
    shape: "round",
  });
</script>

<template>
  <VButton
    :shape="props.shape"
    :size="props.size"
    :class="[$style.chip, { [$style.active]: props.active }]"
  >
    <span :class="{ [$style.placeholder]: props.value == null }">
      {{ props.value ?? props.placeholder }}
    </span>
  </VButton>
</template>

<style lang="scss" module>
  .chip {
    outline: 1px solid transparent;
    outline-offset: -1px;
  }

  .active {
    outline-color: #facc15;
  }

  .placeholder {
    color: var(--muted-foreground);
  }
</style>
